export default "__VITE_ASSET__C$GnvJbT__"